import Vue from 'vue';
import store from '../store/store';
import router from '@/router';

const _getDateFormat = (date) => {
  let createdAt = new Date(date);
  let newDate = new Date();
  var options = { day: 'numeric', month: 'long' };
  const diffTime = Math.abs(new Date().getTime() - createdAt.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
  // Today
  if (diffHours <= 6) {
    return createdAt.toString().split(' ')[4].substring(0, 5);
  }
  if (diffHours >= 6 && diffHours <= 24) {
    return diffHours + ' saat önce';
  }
  // Yesterday
  else if (diffDays >= 1 && diffDays <= 3) {
    return diffDays.toString() + ' gün önce';
  }
  // Older
  else {
    if (store.state.language === 'tr') {
      return createdAt.toLocaleDateString('tr-TR', options);
    } else if (store.state.language === 'en') {
      return createdAt.toLocaleDateString('en-EN', options);
    }
  }
};

const _setPageLoading = (status) => {
  store.state.pageLoadingStatus = status;
};

const _openLink = (link, type = '_target') => {
  console.log('url : ', url);
  let url = link;
  if (!url.includes('http')) {
    url = 'https://' + url;
  }
  window.open(url, type);
};

const _notificationNavigate = (item) => {
  console.log('Item : ', item);
  try {
    const linkType = item.LinkType;
    const link = item.Link;
    let screen = item.Link;
    let extraData = item.Extra && item.Extra.length > 0 ? item.Extra : null;
    let extraType =
      item.ExtraType && item.ExtraType.length > 0 ? item.extraType : null;
    if (item) {
      console.log('exta data : ', extraData);
      switch (linkType) {
        case 'screen':
          console.log('Screen > ', screen);
          // if (extraData) {
          //   router.push({ path: `/myProfile`});
          // }
          if (screen === 'PostDetail') {
            router.push({ path: `/postDetail/${extraData}` });
          } else if (screen === 'Comments') {
            router.push({ path: `/postDetail/${extraData}` });
          } else if (screen === 'Notifications') {
            router.push({ path: `/notifications` });
          } else if (screen === 'Chat') {
            router.push({ path: `/chat` });
          } else if (screen === 'Survey') {
            router.push({ path: `/surveyDetail/${extraData}` });
          } else if (screen === 'Broadcast') {
            //Yeni bir canlı yayın oluştu katılmak ister misiniz?
            console.log('extra data :', extraData);
            store.state.getOnGoingBroadcastsId = extraData;
            store.state.joinLiveStreamDialoStatus = true;
            // router.push({ path: `/joinLiveStream/${extraData}`})
          } else if (screen === 'LiveStreamRequest') {
            //Canlı yayın talebiniz onaylanmıştır.
            store.state.liveStreamStartInfoDialogShow = true;
            router.push({ path: `/home` });
          } else if (screen === 'RequestBroadcast') {
            //Yeni bir canlı yayın isteği oluşturuldu.
            router.push({ path: `/liveStreamRequest` });
          } else if (screen === 'RejectLiveStream') {
            //Canlı yayın talebiniz reddedilmiştir
            router.push({ path: `/home` });
          } else if (screen === 'RejectLiveStream') {
            router.push({ path: `/chat` });
          } else if (screen === 'ThanksDetail') {
            console.log('exta data : ', extraData);
            store.state.thanksDetailUserId = extraData;
            store.state.thanksDetailDialogStatus = true;
          } else {
            let screen = getWebScreenName(extraType);
            router.push({ path: `/${screen}` });
          }
          break;
        case 'external_link':
          if (screen.includes('http')) {
            this.openLink(screen);
          } else {
            this.openLink(`http://${screen}`);
          }
          break;
        case 'link':
          this.openLink(link);
          break;
        default:
          break;
      }
    }
  } catch (error) {
    showError(error);
  }
};

const _getWebScreenName = (screenName) => {
  console.log('screen Name 1 : ', screenName);
  switch (screenName) {
    case 'PostDetail':
      return 'PostDetail';
    case 'Newcomers':
      return 'newComers';
    case 'BornTodayUsers':
      return 'bornTodayUsers';
    default:
      return 'home';
      break;
  }
};

const _gotoProfile = (id) => {
  if (id == store.state.userId) {
    router.push({ name: 'myProfile' });
  } else if (!id) {
    //NO ID
  } else {
    router.push({ path: `/otherProfile/${id}` });
  }
};

const _gotoPostdetail = (id) => {
  console.log('id : ', id);
  router.push({ path: `/postDetail/${id}` });
};

const _detectmob = () => {
  if (navigator.userAgent.match(/Android/i)) {
    console.log('android');
    store.state.platformStoreStatus = true;
  } else if (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i)
  ) {
    console.log('iOS');
    store.state.platformStoreStatus = true;
  } else {
    console.log('web');
  }
};

window.getDateFormat = Vue.prototype.getDateFormat = _getDateFormat;
window.setPageLoading = Vue.prototype.setPageLoading = _setPageLoading;
window.openLink = Vue.prototype.openLink = _openLink;
window.notificationNavigate = Vue.prototype.notificationNavigate =
  _notificationNavigate;
window.getWebScreenName = Vue.prototype.getWebScreenName = _getWebScreenName;
window.gotoProfile = Vue.prototype.gotoProfile = _gotoProfile;
window.gotoPostdetail = Vue.prototype.gotoPostdetail = _gotoPostdetail;
window.detectmob = Vue.prototype.detectmob = _detectmob;
